import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { DataService } from './data.service';

export const PrincipauxResolver = () => {
    const dataService = inject(DataService);
    return dataService.recupererPrincipaux().pipe(
        map((principaux) => {
            const volumes = [];
            const hausses = [];
            const baisses = [];
            const principauxCopy = [...principaux];
            for (let i = 0; i <= 4; i++) {
                let min = principaux[0];
                let max = principaux[0];
                let vol = principaux[0];

                for (let j = 1; j < principaux.length; j++) {
                    if (principaux[j].change > max.change) max = principaux[j];
                    if (principaux[j].change < min.change) min = principaux[j];
                    if (principaux[j].volume > vol.volume) vol = principaux[j];
                }

                volumes.push(vol);
                hausses.push(max);
                baisses.push(min);

                principaux.splice(principaux.indexOf(vol), 1);
                principaux.splice(principaux.indexOf(max), 1);
                principaux.splice(principaux.indexOf(min), 1);
            }
            return [volumes, hausses, baisses, principauxCopy];
        }),
        catchError(() => of([]))
    );
};
